{
    "CallControlMcError": "Ocorreu um erro ao tentar se conectar ao",
    "CallControlActionError": "Ocorreu um erro ao tentar executar a ação",
    "CallControlCompleteTransferError": "Ocorreu um erro ao concluir a transferência",
    "CallControlPickupCallError": "Ocorreu um erro ao capturar a chamada",
    "CallControlChangingDndError": "Ocorreu um erro ao alterar o estado de Não Incomodar para ",
    "CallControlConnectionUpdate": "Ocorreu um erro na atualização da ligação",
    "CallControlDeletePhantom": "Ocorreu um erro ao tentar remover a chamada fantasma.",
    "CallControlAcdStatusUpdate": "Ocorreu um erro na atualização do estado do ACD",
    "CallControlMonitoringActionError": "Ocorreu um erro na ação de monitorização",
    "CallControlUserInfoMissing": "As informações do utilizador estão em falta. Isso pode indicar que não está mais autenticado. Tente sair e entrar novamente.",
    "CallControlTelPartDevError": "Servidor de telefonia, Partição, Agente ou Dispositivo não estavam disponíveis.",
    "NAME": "Callcontrolorrors",
    "CallControlSetAccountCode": "Ocorreu um erro ao tentar definir o código de conta"
}